import React, { useCallback, useState } from 'react'
// import HandyBankLogo from 'custom/assets/logo/IZB-LOGO-SMALL.svg'
import SettingsLogo from 'custom/assets/common-icons/settings.svg'
import './header.css'
import { useHistory } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import MediumModal from '../../../components/Modal/MediumModel'
import { Container } from 'react-bootstrap'
import NeoButton from '../../../components/NeoButton/NeoButton'
import ListLogo from 'custom/assets/common-icons/List.svg'
import AuthService from '../../../services/auth.service'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import NotificationService from '../../../services/notification.service'
import {
  getUserDetailsSelector,
  profileImageDetailsSelector,
} from '../../../store/selectors/app.selector'
import LogOutLogo from 'custom/assets/common-icons/Logout.svg'
import UserImage from 'custom/assets/dashboard/dummy-user.png'
import { useTranslation } from 'react-i18next'
import { BUTTON_KEYS, HEADER_KEYS, LANDING_PAGE_KEYS, MODAL_KEYS } from '../../../utils/translation-constants'
import { setAppLanguage } from '../../../store/actions/app.actions'
import i18next from "i18next";

export default function Header() {
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const profile = useSelector(getUserDetailsSelector)
  const image = useSelector(profileImageDetailsSelector)
  const { t } = useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <MediumModal bgBlur={true}>
        <div className='row' style={{ width: 385 }}>
          <div className='col-2'>
            <img src={LogOutLogo} style={{ marginTop: 20 }} />
          </div>

          <div className='col-10'>
            <div className='my-4'>
              <h6 className='font-weight-bolder log-out-text' style={{ fontStyle: 18 }}>
                {t(MODAL_KEYS.LOGOUT_MESSAGE)}
              </h6>
            </div>
            <div className='d-flex align-items-center'>
              <div className='col-6'>
                <NeoButton
                  tabIndex='1'
                  mode='newDesign'
                  text={t(BUTTON_KEYS.YES)}
                  type='button'
                  onClick={async () => {
                    try {
                      const response = await AuthService.postLogout({})
                      if (response.status === 200) {
                        NotificationService.showSuccessMessage(response.data['message'])
                      }
                      dispatch({ type: 'USER_LOGOUT' })
                      dispatch(setAppLanguage('EN'))
                      i18next.changeLanguage('EN')
                    } catch (err) {
                      console.log(err)
                      dispatch({ type: 'USER_LOGOUT' })
                      dispatch(setAppLanguage('EN'))
                      i18next.changeLanguage('EN')
                      // toast('Error in Logging Out.')
                    }
                  }}
                />
              </div>
              <div className='col-6 back-cancel-btn-container'>
                <button
                  tabIndex={'2'}
                  style={{ textAlign: 'left' }}
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  onClick={hideModal}>
                  {t(BUTTON_KEYS.CANCEL)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </MediumModal>
    ),
    [],
  )

  const handleLogout = useCallback(async () => {
    showModal()
  }, [])

  return (
    <>
      <div className='header-new-section'>
        <Container style={{ height: 'inherit' }}>
          <div
            className='d-flex'
            style={{ justifyContent: 'space-between', alignItems: 'center', height: 'inherit' }}>
            <div
              className='row'
              style={{
                backgroundColor: 'white',
                height: '75px',
                width: '412px',
                transform: 'skew(144deg)',
              }}>
              {/* <img
                className='col-sm-4'
                width={88}
                height={78}
                src={HandyBankLogo}
                style={{ transform: 'skew(36deg)' }}
              /> */}
              <div className='col-sm-4 logo-section'></div>
              <div className='col-sm-8' style={{ marginTop: '21px', transform: 'skew(36deg)' }}>
                <h6>{t(HEADER_KEYS.TITTLE)}</h6>
                <span className='sub-header-new-section'>{t(HEADER_KEYS.SUBTITLE)}</span>
              </div>
            </div>
            <div className='d-flex'>
              <div id='dropdown' style={{ position: 'relative' }}>
                {location.pathname === '/dashboard' && (
                  <>
                    <img src={SettingsLogo} />
                    <div className='dropdown-content' style={{ top: '36px' }}>
                      <div onClick={() => history.push('/profile')}>{t(HEADER_KEYS.PROFILE)}</div>
                      <div onClick={() => history.push('/change-password')}>
                        {t(HEADER_KEYS.CHANGE_PASSWORD)}
                      </div>
                      <div onClick={() => handleLogout()}>{t(HEADER_KEYS.LOGOUT)}</div>
                    </div>
                  </>
                )}
                {location.pathname !== '/dashboard' && (
                  <>
                    <div className='d-flex'>
                      <div
                        className='font-weight-600 text-light pr-2'
                        style={{ fontSize: '13px', marginTop: '7px' }}>
                        {t(LANDING_PAGE_KEYS.HI)}, {profile?.firstName} {profile?.lastName}
                      </div>
                      <div className='pr-2'>
                        {image !== null && (
                          <img
                            src={`data:image/png;base64, ${image && (image.imageData || image)}`}
                            alt='user image'
                            height='35'
                            width='35'
                            style={{ borderRadius: '10px' }}
                          />
                        )}
                        {image === null && (
                          <img
                            src={UserImage}
                            alt='user image'
                            height='35'
                            width='35'
                            style={{ borderRadius: '10px' }}
                          />
                        )}
                      </div>
                    </div>
                    <div className='dropdown-content' style={{ left: '115px' }}>
                      <div onClick={() => history.push('/profile')}>{t(HEADER_KEYS.PROFILE)}</div>
                      <div onClick={() => history.push('/change-password')}>
                        {t(HEADER_KEYS.CHANGE_PASSWORD)}
                      </div>
                      <div onClick={() => handleLogout()}>{t(HEADER_KEYS.LOGOUT)}</div>
                    </div>
                  </>
                )}
              </div>
              <div></div>
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}
